export function getDefaultOrientation() {
	if (
		window.innerWidth < 600 &&
		!document.documentElement.classList.contains("embed")
	) {
		return "ttb";
	}

	return "ltr";
}
